import { Timestamp } from "firebase/firestore";

export const gamificationToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const payload = {
        idTenant,
        
        memberAttendancePresent: Number(data.memberAttendancePresent),
        memberAttendanceExcused: Number(data.memberAttendanceExcused),
        memberAttendanceUnexcused: Number(data.memberAttendanceUnexcused),

        teacherAttendancePresent: Number(data.teacherAttendancePresent),
        teacherAttendanceExcused: Number(data.teacherAttendanceExcused),
        teacherAttendanceUnexcused: Number(data.teacherAttendanceUnexcused),

        minScoreToPassPercent: Number(data.minScoreToPassPercent),
        requireFundamentalsMaxScore: !!data.requireFundamentalsMaxScore,
        xpRewardMemberPass: Number(data.xpRewardMemberPass),
        xpRewardTeacherPass: Number(data.xpRewardTeacherPass),

        rankingCalculationStrategy: data.rankingCalculationStrategy,
        attendanceStreakRequired: Number(data.attendanceStreakRequired),
        attendanceStreakBonusXp: Number(data.attendanceStreakBonusXp),
        achievements: Array.isArray(data.achievements) ? data.achievements.map((a) => ({ ...a })) : [],
        levelRanks: Array.isArray(data.levelRanks) ? data.levelRanks.map((r) => ({ ...r })) : [],

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

export const gamificationFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
